import React, { useState, useContext, useEffect } from "react";
import { GlobalContext } from "../utils/GlobalContext";
import { Avatar, TextInput, Select, Button } from "@mantine/core";
import { DatePicker } from "@mantine/dates";

const DoctorProfile = () => {
  // Hooks
  const { user } = useContext(GlobalContext);
  const [doctorType, setDoctorType] = useState("");

  useEffect(() => {
    console.log(user);
  });

  return (
    <div
      className="Home"
      style={{
        padding: "100px 8vw 15px 8vw",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div style={{ display: "flex" }}>
        <div
          className="col1"
          style={{
            marginRight: 100,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar color="green" radius="xl" size={250}>
            DR
          </Avatar>
          <Button style={{ marginTop: 25, width: 200 }} color="indigo">
            Change Picture
          </Button>
          <Button
            style={{ marginTop: 20, width: 200 }}
            color="red"
            variant="outline"
          >
            Delete Picture
          </Button>
        </div>
        <div className="col2">
          <div style={{ display: "flex" }}>
            <TextInput
              placeholder="First Name"
              label="First Name"
              style={{ marginBottom: 20, marginRight: 75, width: 250 }}
            />
            <TextInput
              placeholder="Last Name"
              label="Last Name"
              style={{ marginBottom: 20, width: 250 }}
            />
          </div>
          <div style={{ display: "flex" }}>
            <DatePicker
              placeholder="Date of Birth"
              label="Date of Birth"
              style={{ marginBottom: 20, marginRight: 75, width: 250 }}
            />
          </div>
          <div style={{ display: "flex" }}>
            <Select
              label="Gender"
              placeholder="Gender"
              style={{ marginBottom: 20, marginRight: 75, width: 250 }}
              data={[
                { value: "male", label: "Male" },
                { value: "female", label: "Female" },
              ]}
            />
          </div>
          <div style={{ display: "flex" }}>
            <TextInput
              placeholder="Address"
              label="Address"
              style={{ marginBottom: 20, marginRight: 75, width: 250 }}
            />
            <TextInput
              placeholder="Email"
              label="Email"
              style={{ marginBottom: 20, marginRight: 75, width: 250 }}
            />
          </div>
          <div style={{ display: "flex" }}>
            <TextInput
              placeholder="Phone Number"
              label="Phone Number"
              style={{ marginBottom: 20, marginRight: 75, width: 250 }}
            />
          </div>
          <div style={{ display: "flex" }}>
            <Select
              label="Doctor Type"
              placeholder="Doctor Type"
              style={{ marginBottom: 20, marginRight: 75, width: 250 }}
              data={[
                { value: "general", label: "General" },
                { value: "specialist", label: "Specialist" },
              ]}
              onChange={(e) => setDoctorType(e)}
            />
            {doctorType === "specialist" && (
              <div style={{ display: "flex" }}>
                <TextInput
                  placeholder="e.g. Neurosurgeon"
                  label="Specialist Type"
                  style={{ marginBottom: 20, marginRight: 75, width: 250 }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorProfile;
